/* Aurelia Storefront System
   Premium YOUR BAG drawer + real Shopify Ajax cart.
   - Intercepts every Add to Bag/Cart so nothing redirects to /cart
   - Timer, free-shipping progress, upsell, shipping-protection toggle, live totals
   - One cart state (Shopify). No parallel cart. Fully delegated (editor-safe). */
(function () {
  'use strict';
  if (window.__aurStorefront) { return; }
  window.__aurStorefront = true;

  var doc = document;
  var body = doc.body;
  var lastFocus = null;
  var current = null;
  var busy = false;
  var savedScroll = 0;
  var lastProductCount = 0;
  var compareMap = {};
  var CFG = {};
  var UPSELL = null;
  var TKEY = 'aurTimerStart';

  function el(id) { return doc.getElementById(id); }
  function qsa(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  function readConfig() {
    var s = el('aur-shell');
    CFG = {
      money: (s && s.getAttribute('data-money-format')) || '£{{amount}}',
      timerMinutes: parseInt((s && s.getAttribute('data-timer-minutes')) || '10', 10),
      timerMsg: (s && s.getAttribute('data-timer-msg')) || 'Complete your order within {time} minutes.',
      timerZero: (s && s.getAttribute('data-timer-zero')) || 'Your items are waiting.',
      threshold: parseInt((s && s.getAttribute('data-free-shipping-threshold')) || '0', 10),
      shipProgress: (s && s.getAttribute('data-ship-progress')) || 'You are {amount} away from Free Express Shipping',
      shipSuccess: (s && s.getAttribute('data-ship-success')) || 'Congratulations! You qualify for Free Express Shipping',
      protectionId: parseInt((s && s.getAttribute('data-protection-variant')) || '0', 10)
    };
    var ud = el('aur-upsell-data');
    if (ud) { try { UPSELL = JSON.parse(ud.textContent); } catch (e) { UPSELL = null; } }
  }

  function formatMoney(cents) {
    var value = (cents == null ? 0 : cents);
    function withComma(num, decimals) {
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      return parts.join('.');
    }
    var out = CFG.money || '£{{amount}}';
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(value, 0));
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value, 2));
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withComma(value, 0));
    out = out.replace(/\{\{\s*amount\s*\}\}/g, withComma(value, 2));
    return out;
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ---------- scroll lock + focus trap ---------- */
  function lockScroll(on) {
    if (on) {
      savedScroll = window.scrollY || window.pageYOffset || 0;
      body.style.position = 'fixed'; body.style.top = (-savedScroll) + 'px';
      body.style.left = '0'; body.style.right = '0'; body.style.width = '100%';
    } else {
      body.style.position = ''; body.style.top = ''; body.style.left = '';
      body.style.right = ''; body.style.width = ''; window.scrollTo(0, savedScroll);
    }
  }
  function focusables(container) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
      .filter(function (n) { return n.offsetParent !== null; });
  }
  function onKeydown(e) {
    if (!current) return;
    if (e.key === 'Escape') { e.preventDefault(); closeAll(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(current); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDrawer(node, trigger) {
    if (!node) return;
    lastFocus = trigger || doc.activeElement; current = node;
    var bd = el('aur-backdrop'); if (bd) bd.setAttribute('data-open', 'true');
    node.setAttribute('data-open', 'true'); node.removeAttribute('inert');
    lockScroll(true); doc.addEventListener('keydown', onKeydown, true);
    window.setTimeout(function () { var f = focusables(node); if (f.length) f[0].focus(); else node.focus(); }, 60);
  }
  function closeAll() {
    var bd = el('aur-backdrop'); if (bd) bd.setAttribute('data-open', 'false');
    qsa('.aur-drawer').forEach(function (d) { d.setAttribute('data-open', 'false'); d.setAttribute('inert', ''); });
    doc.removeEventListener('keydown', onKeydown, true); lockScroll(false);
    if (lastFocus && typeof lastFocus.focus === 'function') { try { lastFocus.focus(); } catch (e) {} }
    current = null;
  }
  function openMenu(t) { openDrawer(el('aur-menu'), t); }
  function openCart(t) { openDrawer(el('aur-cart'), t); refreshCart(); }

  var toastTimer = null;
  function toast(msg) {
    var t = el('aur-toast'); if (!t) return;
    var m = t.querySelector('.aur-toast__msg'); if (m) m.textContent = msg;
    t.hidden = false; window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.hidden = true; }, 3000);
  }

  /* ---------- compare-at map (accurate savings) ---------- */
  function ensureCompare(items) {
    var handles = {};
    items.forEach(function (it) {
      if (it.variant_id === CFG.protectionId) return;
      if (compareMap[it.variant_id] === undefined && it.handle) handles[it.handle] = true;
    });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'X-Aur-Internal': '1' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { (p.variants || []).forEach(function (v) { compareMap[v.id] = v.compare_at_price || 0; }); })
        .catch(function () {});
    }));
  }

  /* ---------- item markup ---------- */
  var ICON_REMOVE = '<svg width=16 height=16 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.5><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_MINUS = '<svg width=14 height=14 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.8><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg width=14 height=14 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.8><path d="M12 5v14M5 12h14"/></svg>';

  function itemHtml(it) {
    var img = it.image
      ? '<img class=aur-cart-item__media src="' + esc(it.image) + '" alt="' + esc(it.product_title || '') + '" width=72 height=88 loading=lazy>'
      : '<span class=aur-cart-item__media aria-hidden=true></span>';
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class=aur-cart-item__variant>' + esc(it.variant_title) + '</span>' : '';
    var compareUnit = compareMap[it.variant_id] || 0;
    var unit = it.final_price;
    var hasCompare = compareUnit > unit;
    var save = '';
    var priceCell;
    if (hasCompare) {
      var pct = Math.round((compareUnit - unit) / compareUnit * 100);
      save = '<span class=aur-cart-item__save>SAVE ' + pct + '%</span>';
      priceCell = '<del>' + formatMoney(compareUnit * it.quantity) + '</del>' + formatMoney(it.final_line_price);
    } else {
      priceCell = formatMoney(it.final_line_price);
    }
    return '' +
      '<div class=aur-cart-item data-key="' + esc(it.key) + '" data-vid="' + it.variant_id + '" data-busy=false>' +
        img +
        '<div class=aur-cart-item__body>' +
          '<div class=aur-cart-item__top>' +
            '<h3 class=aur-cart-item__name><a href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a></h3>' +
            '<button type=button class=aur-cart-item__remove data-remove aria-label="Remove item">' + ICON_REMOVE + '</button>' +
          '</div>' + variant + save +
          '<div class=aur-cart-item__foot>' +
            '<div class=aur-qty>' +
              '<button type=button data-dec aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
              '<span class=aur-qty__val aria-live=polite>' + it.quantity + '</span>' +
              '<button type=button data-inc aria-label="Increase quantity">' + ICON_PLUS + '</button>' +
            '</div>' +
            '<span class=aur-cart-item__price>' + priceCell + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* ---------- upsell ---------- */
  function renderUpsell(cart) {
    var wrap = el('aur-upsell'); if (!wrap) return;
    if (!UPSELL || !UPSELL.variants || !UPSELL.variants.length) { wrap.hidden = true; return; }
    var inCart = cart.items.some(function (it) { return UPSELL.variants.some(function (v) { return v.id === it.variant_id; }); });
    if (inCart) { wrap.hidden = true; return; }
    var card = el('aur-upsell-card'); if (!card) return;
    var multi = UPSELL.variants.length > 1;
    var firstAvail = null;
    for (var i = 0; i < UPSELL.variants.length; i++) { if (UPSELL.variants[i].available) { firstAvail = UPSELL.variants[i]; break; } }
    var sel = firstAvail || UPSELL.variants[0];
    var soldOut = !firstAvail;
    var img = UPSELL.image ? '<img class=aur-upsell__img src="' + esc(UPSELL.image) + '" alt="' + esc(UPSELL.title) + '" width=60 height=72 loading=lazy>' : '<span class=aur-upsell__img></span>';
    var hasCompare = sel.compare_at && sel.compare_at > sel.price;
    var badge = hasCompare ? '<span class=aur-upsell__badge>SAVE ' + Math.round((sel.compare_at - sel.price) / sel.compare_at * 100) + '%</span>' : '';
    var compare = hasCompare ? '<span class=aur-upsell__compare>' + formatMoney(sel.compare_at) + '</span>' : '';
    var options = '';
    if (multi) {
      options = '<select class=aur-upsell__select id=aur-upsell-select aria-label="Choose option">';
      UPSELL.variants.forEach(function (v) { options += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === sel.id ? ' selected' : '') + '>' + esc(v.title) + (v.available ? '' : ' - sold out') + '</option>'; });
      options += '</select>';
    }
    var btn = soldOut
      ? '<button type=button class=aur-upsell__add disabled>Sold out</button>'
      : '<button type=button class=aur-upsell__add data-upsell-add data-vid="' + sel.id + '">Add to bag</button>';
    card.innerHTML =
      img +
      '<div class=aur-upsell__info>' +
        '<p class=aur-upsell__title>' + esc(UPSELL.title) + '</p>' +
        '<div class=aur-upsell__prices><span class=aur-upsell__price>' + formatMoney(sel.price) + '</span>' + compare + badge + '</div>' +
        options + btn +
      '</div>';
    wrap.hidden = false;
  }

  /* ---------- timer ---------- */
  function timerStart() { if (!sessionStorage.getItem(TKEY)) sessionStorage.setItem(TKEY, String(Date.now())); }
  function timerClear() { try { sessionStorage.removeItem(TKEY); } catch (e) {} }
  function timerTick() {
    var t = el('aur-timer'); if (!t) return;
    if (lastProductCount <= 0) { t.hidden = true; return; }
    var start = parseInt(sessionStorage.getItem(TKEY) || '0', 10);
    if (!start) { t.hidden = true; return; }
    var txt = el('aur-timer-text'); if (!txt) return;
    var rem = (CFG.timerMinutes * 60000) - (Date.now() - start);
    if (rem > 0) {
      var s = Math.ceil(rem / 1000); var mm = Math.floor(s / 60); var ss = s % 60;
      var clock = mm + ':' + (ss < 10 ? '0' : '') + ss;
      txt.innerHTML = esc(CFG.timerMsg).replace('{time}', '<span class=aur-timer__clock>' + clock + '</span>');
    } else {
      txt.textContent = CFG.timerZero;
    }
    t.hidden = false;
  }

  /* ---------- paint ---------- */
  function paint(cart) {
    var productItems = cart.items.filter(function (it) { return it.variant_id !== CFG.protectionId; });
    var productCount = productItems.reduce(function (a, it) { return a + it.quantity; }, 0);
    lastProductCount = productCount;
    var hasItems = productCount > 0;

    var wrapHas = el('aur-cart-has'); var wrapEmpty = el('aur-cart-empty');
    if (wrapHas) wrapHas.style.display = hasItems ? 'flex' : 'none';
    if (wrapEmpty) wrapEmpty.style.display = hasItems ? 'none' : 'flex';
    qsa('[data-aur-cart-count]').forEach(function (n) { n.textContent = productCount; });
    syncHeaderBubble(cart.item_count);

    if (!hasItems) { timerClear(); var tt = el('aur-timer'); if (tt) tt.hidden = true; return; }

    var list = el('aur-cart-list'); if (list) list.innerHTML = productItems.map(itemHtml).join('');

    // totals
    var subtotal = productItems.reduce(function (a, it) { return a + it.final_line_price; }, 0);
    var savings = 0;
    productItems.forEach(function (it) { var c = compareMap[it.variant_id] || 0; if (c > it.final_price) savings += (c * it.quantity - it.final_line_price); });
    setText('aur-sum-subtotal', formatMoney(subtotal));
    var savRow = el('aur-sum-savings-row'); if (savRow) { savRow.hidden = savings <= 0; setText('aur-sum-savings', '-' + formatMoney(savings)); }
    var protItem = cart.items.filter(function (it) { return it.variant_id === CFG.protectionId; })[0];
    var protRow = el('aur-sum-protect-row'); if (protRow) { protRow.hidden = !protItem; if (protItem) setText('aur-sum-protect', formatMoney(protItem.final_line_price)); }
    setText('aur-sum-total', formatMoney(cart.total_price));

    // free shipping progress (based on merchandise subtotal, excludes protection)
    var ship = el('aur-ship');
    if (ship) {
      if (CFG.threshold <= 0) { ship.hidden = true; }
      else {
        ship.hidden = false;
        var fill = el('aur-ship-fill'); var st = el('aur-ship-text');
        if (subtotal >= CFG.threshold) { if (fill) fill.style.width = '100%'; if (st) st.innerHTML = esc(CFG.shipSuccess); }
        else {
          var pctw = Math.max(3, Math.min(100, Math.round(subtotal / CFG.threshold * 100)));
          if (fill) fill.style.width = pctw + '%';
          if (st) st.innerHTML = esc(CFG.shipProgress).replace('{amount}', '<strong>' + formatMoney(CFG.threshold - subtotal) + '</strong>');
        }
      }
    }

    // protection toggle reflects real state
    var toggle = el('aur-protect-toggle'); if (toggle) toggle.checked = !!protItem;

    renderUpsell(cart);
    timerStart();
    timerTick();
  }
  function setText(id, v) { var n = el(id); if (n) n.textContent = v; }
  function syncHeaderBubble(count) { qsa('.cart-bubble__text-count').forEach(function (n) { n.textContent = count > 0 ? (count > 99 ? '99+' : count) : ''; }); }
  function setError(msg) { var e = el('aur-cart-error'); if (!e) return; if (msg) { var t = e.querySelector('.aur-cart-error__text'); if (t) t.textContent = msg; e.hidden = false; } else { e.hidden = true; } }

  function render(cart) { return ensureCompare(cart.items).then(function () { paint(cart); }); }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json', 'X-Aur-Internal': '1' } })
      .then(function (r) { return r.json(); }).then(function (c) { return render(c); }).catch(function () {});
  }

  /* ---------- cart mutations ---------- */
  function changeLine(key, quantity, node) {
    if (busy) return; busy = true; setError('');
    if (node) node.setAttribute('data-busy', 'true');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Aur-Internal': '1' }, body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) { if (!res.ok) { setError((res.body && res.body.message) || 'We could not update your bag. Please try again.'); return refreshCart(); } return render(res.body); })
      .catch(function () { setError('Something went wrong. Please try again.'); })
      .then(function () { busy = false; });
  }
  function addVariant(id, qty) {
    if (busy) return Promise.resolve(); busy = true; setError('');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Aur-Internal': '1' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) { if (!res.ok) { setError((res.body && res.body.description) || 'This item could not be added.'); } busy = false; return res.ok; })
      .catch(function () { busy = false; setError('This item could not be added.'); return false; });
  }
  function addForm(form) {
    if (busy) return; busy = true; setError('');
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Aur-Internal': '1' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) { busy = false; if (!res.ok) { setError((res.body && res.body.description) || 'This item could not be added.'); openCart(); return; } onAdded(); })
      .catch(function () { busy = false; setError('This item could not be added.'); });
  }
  function onAdded() { timerStart(); refreshCart().then(function () { openCart(); toast('Added to your bag'); }); }

  function toggleProtection(on) {
    if (!CFG.protectionId) return;
    if (busy) { var tg = el('aur-protect-toggle'); if (tg) tg.checked = !on; return; }
    busy = true;
    fetch('/cart.js', { headers: { 'X-Aur-Internal': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = c.items.filter(function (it) { return it.variant_id === CFG.protectionId; })[0];
        if (on) {
          if (line) { busy = false; return refreshCart(); }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Aur-Internal': '1' }, body: JSON.stringify({ id: CFG.protectionId, quantity: 1 }) })
            .then(function () { busy = false; return refreshCart(); });
        } else {
          if (!line) { busy = false; return refreshCart(); }
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Aur-Internal': '1' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function () { busy = false; return refreshCart(); });
        }
      })
      .catch(function () { busy = false; refreshCart(); });
  }

  /* ---------- delegated events (bound once) ---------- */
  function isCartTrigger(t) { return t.closest('[data-testid="cart-drawer-trigger"]') || t.closest('a.action__cart') || t.closest('a[href$="/cart"]'); }
  function isMenuTrigger(t) { var s = t.closest('#Details-menu-drawer-container summary'); return s ? s : null; }

  function bindOnce() {
    if (window.__aurBound) return; window.__aurBound = true;

    // capture: intercept header triggers
    doc.addEventListener('click', function (e) {
      var mt = isMenuTrigger(e.target);
      if (mt) { e.preventDefault(); e.stopImmediatePropagation(); var d = mt.closest('details'); if (d) d.open = false; openMenu(mt); return; }
      var ct = isCartTrigger(e.target);
      if (ct) { e.preventDefault(); e.stopImmediatePropagation(); openCart(ct); return; }
      var atc = e.target.closest('[data-au-atc], .au-hoverbtn[data-variant-id], [data-add-to-cart][data-variant-id]');
      if (atc && atc.getAttribute('data-variant-id')) {
        var vid = parseInt(atc.getAttribute('data-variant-id') || '0', 10);
        if (vid) {
          e.preventDefault(); e.stopImmediatePropagation();
          var qty = 1;
          var sec = atc.closest('.shopify-section') || doc;
          var qi = sec.querySelector('input[name="quantity"], .quantity__input, [data-quantity-input], input.au-qty-input');
          if (qi && qi.value) { qty = parseInt(qi.value, 10) || 1; }
          addVariant(vid, qty).then(function (ok) { if (ok) onAdded(); else openCart(atc); });
          return;
        }
      }
    }, true);

    // capture: intercept native add-to-cart form submits (prevents /cart redirect)
    doc.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form') : null;
      if (!form) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) { e.preventDefault(); e.stopImmediatePropagation(); addForm(form); }
    }, true);

    // bubble: drawer controls
    doc.addEventListener('click', function (e) {
      if (e.target.closest('[data-aur-close]')) { closeAll(); return; }
      if (e.target.id === 'aur-backdrop') { closeAll(); return; }
      if (e.target.closest('[data-aur-open-cart]')) { e.preventDefault(); openCart(e.target.closest('[data-aur-open-cart]')); return; }
      var acc = e.target.closest('[data-aur-toggle]');
      if (acc) { var panel = doc.getElementById(acc.getAttribute('aria-controls')); var open = acc.getAttribute('aria-expanded') === 'true'; acc.setAttribute('aria-expanded', String(!open)); if (panel) panel.hidden = open; return; }
      var up = e.target.closest('[data-upsell-add]');
      if (up) { var vid = parseInt(el('aur-upsell-select') ? el('aur-upsell-select').value : up.getAttribute('data-vid'), 10); if (vid) { up.disabled = true; addVariant(vid, 1).then(function (ok) { if (ok) { refreshCart().then(function () { toast('Added to your bag'); }); } else { refreshCart(); } }); } return; }
      var item = e.target.closest('.aur-cart-item');
      if (item) {
        if (e.target.closest('[data-inc]')) { var q = parseInt(item.querySelector('.aur-qty__val').textContent, 10) || 1; changeLine(item.getAttribute('data-key'), q + 1, item); }
        else if (e.target.closest('[data-dec]')) { var q2 = parseInt(item.querySelector('.aur-qty__val').textContent, 10) || 1; changeLine(item.getAttribute('data-key'), q2 - 1, item); }
        else if (e.target.closest('[data-remove]')) { changeLine(item.getAttribute('data-key'), 0, item); }
      }
    });

    // protection toggle
    doc.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'aur-protect-toggle') { toggleProtection(e.target.checked); }
    });

    // wrap fetch: catch Horizon/theme AJAX adds (skip our own internal calls)
    if (window.fetch && !window.fetch.__aurWrapped) {
      var orig = window.fetch;
      var wrapped = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var internal = init && init.headers && (init.headers['X-Aur-Internal'] || (init.headers.get && init.headers.get('X-Aur-Internal')));
        var p = orig.apply(this, arguments);
        if (!internal && url && url.indexOf('/cart/add') !== -1) { p.then(function (r) { if (r && r.ok) onAdded(); }).catch(function () {}); }
        else if (!internal && url && (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) { p.then(function (r) { if (r && r.ok) refreshCart(); }).catch(function () {}); }
        return p;
      };
      wrapped.__aurWrapped = true; window.fetch = wrapped;
    }
    window.setInterval(timerTick, 1000);
  }

  function init() {
    if (!el('aur-shell')) return;
    readConfig();
    qsa('.aur-drawer').forEach(function (d) { d.setAttribute('inert', ''); });
    bindOnce();
    refreshCart();
  }

  if (document.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { readConfig(); refreshCart(); });

  window.AureliaStorefront = { openMenu: openMenu, openCart: openCart, closeAll: closeAll, refreshCart: refreshCart };
})();
